export default '/service/standards'
